import * as React from "react";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { ContributionAndWithdrawalBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { processTypeEnum } from "../../../Common/Resource/Contents";

interface IDocumentProps extends IProcessComponentProps {}

interface IDocumentState {}

export class Document extends ProcessComponent<IDocumentProps, IDocumentState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return (
            <>
                <h4 className="h4 mr-10">Documents</h4>
                {this.renderDocuments()}
                <br />
            </>
        );
    }

    private renderDocuments() {
        const customerid = getQueryParameters()["customerid"];
        const claccountid = getQueryParameters()["claccountid"];
        const instructionId = getQueryParameters()["id"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];
        const chargesInformationQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid,
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargesInformation,
            processTypeEnum.Quote
        );
        const termsAndConditionsQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid,
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.TermsAndCondition,
            processTypeEnum.Quote
        );
        return (
            <>
                {this.displayChargesInformation() && (
                    <>
                        <div className="mb-24">
                            <a className="hyperlink">Charges Information</a>
                            <DownloadButton
                                request={chargesInformationQuery}
                                selectedAccount={headAccountHierarchyId}
                            ></DownloadButton>
                        </div>
                    </>
                )}
            </>
        );
    }

    private displayChargesInformation(): boolean {
        const { data } = this.props;
        return (
            this.hasAllocationExceptGBPCash(data?.GiaQuote) ||
            this.hasAllocationExceptGBPCash(data?.ISAQuote) ||
            this.hasAllocationExceptGBPCash(data?.PensionQuote)
        );
    }

    private hasAllocationExceptGBPCash(model: ContributionAndWithdrawalBase): boolean {
        return model?.InstrumentSelections?.Instruments?.some((x) => x.Instrument.Name != "GBP Cash");
    }
}
